import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// Angular Material
import { MatGridListModule, MatCardModule, MatMenuModule, MatIconModule, MatButtonModule, MatTableModule, MatPaginatorModule, MatSortModule, MatToolbarModule, MatSidenavModule, MatListModule, MatTabsModule, MatDialogModule, MatCheckboxModule, MatFormFieldModule, MatInputModule, MatExpansionModule, MatProgressBarModule, MatChipsModule, MatSelectModule, MatTooltipModule, MatBottomSheetModule, MatStepperModule, MatButtonToggleModule, MatProgressSpinnerModule, MatSliderModule, MatSlideToggleModule, MatRadioModule } from '@angular/material';
// Angular CDK
import { LayoutModule } from '@angular/cdk/layout';
// FlexLayout
import { FlexLayoutModule } from '@angular/flex-layout';
// Networking
import { HttpClientModule } from '@angular/common/http';
// Routing
import { AppRouting } from './/app-routing.module';
import { RouteReuseStrategy } from '@angular/router';
import { CustomReuseStrategy } from './app-routing-reuse-strategy';
// OpenID Auth Services
import { InitService } from './services/init.service'
import { ConfigService } from './services/config.service'
import { AuthService } from './services/auth.service'
// Charts
import { NgxEchartsModule } from 'ngx-echarts'; // For bar graph
// Datepickers
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'; // bootstrap range datepicker (analytics)
import { SatDatepickerModule, SatNativeDateModule } from 'saturn-datepicker'; // material range picker (security events)
// FontAwesome Icons
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faVideo, faVideoSlash } from '@fortawesome/free-solid-svg-icons';
library.add(faVideo, faVideoSlash);
// Password Strength indicator
import { MatPasswordStrengthModule } from '@angular-material-extensions/password-strength';

import 'hammerjs'; // for touch events on material sliders

// Components
import { AnalyticsComponent } from './components/analytics/analytics.component';
import { TableGatesComponent } from './components/table-gates/table-gates.component';
import { ShellComponent } from './components/shell/shell.component';
import { TableEventsComponent } from './components/table-events/table-events.component';
import { VideoComponent } from './components/security-event/video/video.component';
import { StoreSelectorComponent } from './components/store-selector/store-selector.component';
import { DatepickerMonthComponent } from './components/analytics/datepicker-month/datepicker-month.component';
import { GateDialogComponent } from './components/table-gates/gate-dialog/gate-dialog.component';
import { BarGraphComponent } from './components/analytics/bar-graph/bar-graph.component';
import { NumberCardComponent } from './components/analytics/number-card/number-card.component';
import { SecurityEventComponent } from './components/security-event/security-event.component';
import { ControlsComponent } from './components/table-events/controls/controls.component';
import { CompareComponent } from './components/analytics/compare/compare.component';
import { DatepickerRangeComponent } from './components/analytics/datepicker-range/datepicker-range.component';
import { NotificationsDialogComponent } from './components/shell/notifications-dialog/notifications-dialog.component';
import { StoreHoursComponent } from './components/store-hours/store-hours.component';
import { ChangePasswordDialogComponent } from './components/change-password/change-password-dialog.component';
import { UserService } from './services/user.service';

@NgModule({
  declarations: [
    AppComponent,
    AnalyticsComponent,
    TableGatesComponent,
    ShellComponent,
    TableEventsComponent,
    VideoComponent,
    StoreSelectorComponent,
    CompareComponent,
    DatepickerMonthComponent,
    GateDialogComponent,
    BarGraphComponent,
    NumberCardComponent,
    SecurityEventComponent,
    ControlsComponent,
    DatepickerRangeComponent,
    NotificationsDialogComponent,
    StoreHoursComponent,
    ChangePasswordDialogComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatGridListModule,
    MatCardModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    LayoutModule,
    MatToolbarModule,
    MatSidenavModule,
    MatListModule,
    MatTabsModule,
    MatDialogModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatExpansionModule,
    MatProgressBarModule,
    MatChipsModule,
    MatSelectModule,
    MatStepperModule,
    FormsModule,
    ReactiveFormsModule,
    MatTooltipModule,
    MatBottomSheetModule,
    NgxEchartsModule,
    MatButtonToggleModule,
    MatProgressSpinnerModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatRadioModule,

    NgbModule.forRoot(), // Angular Bootstrap
    SatDatepickerModule,
    SatNativeDateModule,

    HttpClientModule,
    FlexLayoutModule,
    AppRouting,
    FontAwesomeModule,
    MatPasswordStrengthModule.forRoot()
  ],
  entryComponents: [
    TableGatesComponent,
    GateDialogComponent,
    NotificationsDialogComponent,
    StoreSelectorComponent,
    ChangePasswordDialogComponent
  ],

  providers: [
    InitService,
    AuthService,
    ConfigService,
    UserService,
    { provide: RouteReuseStrategy, useClass: CustomReuseStrategy },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
